type PrivacyNoticeLanguage = 'en' | 'vn';

type PrivacyNoticeEnvironment = 'prod' | 'uat';

function normalizeEnvironmentName(environmentValue?: string): PrivacyNoticeEnvironment | undefined {
  if (!environmentValue) {
    return undefined;
  }

  const normalizedValue = environmentValue.trim().toUpperCase();

  if (normalizedValue.includes('UAT')) {
    return 'uat';
  }

  if (normalizedValue.includes('PROD')) {
    return 'prod';
  }

  return undefined;
}

function detectEnvironmentFromHostname(): PrivacyNoticeEnvironment {
  if (typeof window === 'undefined') {
    return 'prod';
  }

  return window.location.hostname.toLowerCase().includes('uat') ? 'uat' : 'prod';
}

export function getPrivacyNoticePath(
  language: PrivacyNoticeLanguage,
  ...environmentValues: Array<string | undefined>
): string {
  for (const environmentValue of environmentValues) {
    const normalizedEnvironment = normalizeEnvironmentName(environmentValue);

    if (normalizedEnvironment) {
      return `/one-trust/${normalizedEnvironment}/privacy-notice-${language}.html`;
    }
  }

  const runtimeEnvironment = detectEnvironmentFromHostname();
  return `/one-trust/${runtimeEnvironment}/privacy-notice-${language}.html`;
}